$('#frmLogin').on("submit", event => {
    event.preventDefault();
    $.ajax({
        url: '/',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        data: $(this).serialize(),
    });
});

$('#frmRamal').on("submit", event => {
    event.preventDefault();
    $.ajax({
        url: '/ramal',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        data: $(this).serialize(),
    });
});